module.exports = __webpack_public_path__ + "static/media/panasonic.cd6506ca.jpg";